<template>
  <div class='checkRecord'>
    <div class="checkRecord_top">
      <el-cascader
        style="margin-right:20px;"
        placeholder="请选择班级"
        :options="classList"
        :show-all-levels="false"
        clearable
        :props="classProp"
        v-model="CheckRecordParams.classid"
        @change="GetCheckRecordlist"
      ></el-cascader>
      <el-cascader
        :options="experList"
        placeholder="请选择实验"
        :show-all-levels="false"
        :props="experProp"
        clearable
        v-model="CheckRecordParams.experimentid"
        @change="GetCheckRecordlist"
      ></el-cascader>
      <el-date-picker
        style="margin-left:20px"
        v-model="selectDate"
        type="datetimerange"
        @change="dateChange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </div>
    <div class="checkRecord_body">
      <el-table
        :data="CheckRecordTableData"
        stripe
        tooltip-effect="dark"
        style="width: 100%"
        max-height="670"
        empty-text="请选择班级实验"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="username"
          label="学生姓名"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="usercode"
          label="学生学号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="classname"
          label="班级"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="okrate"
          label="成功率"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="finishrate"
          label="完成率"
          align="center"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="createdate"
          label="创建时间"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="list"
          label="详情"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleDetails(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="考核记录列表"
        :visible.sync="dialogVisible"
        width="40%"
      >
        <el-table
          :data="CheckDetailsTableData"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
          empty-text="请选择班级实验"
        >
          <el-table-column
            type="index"
            label="序号"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="experimentname"
            label="实验名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="usedtime"
            label="用时"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="fraction"
            label="成绩"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="isnoname"
            label="合格"
            align="center"
            width="100"
          >
          </el-table-column>
        </el-table>
      </el-dialog>
      <div>
        <el-pagination
          style="text-align:center;margin-top:20px;"
          :hide-on-single-page="true"
          :total="total"
          :page-size="CheckRecordParams.pagesize"
          :current-page.sync='CheckRecordParams.pageindex'
          @current-change="GetCheckRecordlist"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      dialogVisible: false,
      classList: [],
      classProp: {
        label: 'orgname',
        value: 'orgid',
        children: 'children',
        expandTrigger: 'hover',
        emitPath: false,
      },
      experList: [],
      experProp: {
        label: 'itemname',
        value: 'itemid',
        children: 'children',
        expandTrigger: 'hover',
        emitPath: false,
      },
      total: 0,
      selectDate: '',
      CheckRecordParams: {
        classid: '',
        experimentid: '',
        startdate: '',
        enddate: '',
        pageindex: 1,
        pagesize: 13
      },
      CheckRecordTableData: [],
      CheckDetailsTableData: [],
    }
  },
  created () {
    this.GetCheckRecordlist()
    this.GetExperTree()
    this.GetUserSpecClassData()
  },
  methods: {
    //获取班级列表
    async GetUserSpecClassData () {
      const res = await Api.userinfo.GetUserSpecClassData()
      this.classList = res.rows.orglist
    },
    //获取实验列表
    async GetExperTree () {
      const res = await Api.sum.GetExperTree()
      this.experList = res.rows
    },
    dateChange (e) {
      this.CheckRecordParams.startdate = e != null ? e[0] : "";
      this.CheckRecordParams.enddate = e != null ? e[1] : "";
      this.GetCheckRecordlist()
    },
    //学生试题考核记录
    async GetCheckRecordlist () {
      const res = await Api.sum.GetCheckRecordlist(this.CheckRecordParams)
      if (res.success != true) return this.$message.info(res.msg)
      this.total = res.total
      this.CheckRecordTableData = res.rows
      for (let index = 0; index < this.CheckRecordTableData.length; index++) {
        const element = this.CheckRecordTableData[index];
        element.finishrate = Math.round(element.finishrate * 100) + '%'
      }
    },
    //查看试题考核记录详情
    handleDetails (e) {
      console.log(e);
      this.CheckDetailsTableData = e.list
      for (let i = 0; i < this.CheckDetailsTableData.length; i++) {
        const element = this.CheckDetailsTableData[i];
        element.usedtime = Math.round(element.usedtime / 60) + '分钟'
      }
      this.dialogVisible = true
    }

  }
}
</script>
<style lang='less' scoped>
.checkRecord {
  width: 100%;
  height: 100%;
  background: #fff;
  .checkRecord_top {
    padding: 15px;
  }
  /deep/.el-dialog {
    border-radius: 7px;
    .el-dialog__header {
      border-bottom: 1px solid #ccc;
      margin: 0 20px;
    }
  }
}
</style>